import { X, Plus } from "lucide-react";
import { useState } from "react";
import { BasicSection } from "./lr-form/BasicSection";
import { RouteSection } from "./lr-form/RouteSection";
import { CargoSection } from "./lr-form/CargoSection";
import { ExtrasSection } from "./lr-form/ExtrasSection";
import { DirectoryWizardModal } from "./masters/DirectoryWizardModal";

export function LRFormModal({ form, set, setForm, setH, setC, pickHirer, hirerContacts, customers, vehicles, drivers, brokers = [], subs = [], onPodFile, editingId, saving, save, onClose, lrDocTypes, reloadCustomers }) {
  const [dirOpen, setDirOpen] = useState(false);
  const companyNames = [form.hirer?.name, form.consignor_name, form.consignee_name,
    ...(form.pickups || []).map((p) => p.company), ...(form.deliveries || []).map((d) => d.company)].filter(Boolean);
  const companyDocTitles = Array.from(new Set(
    customers.filter((c) => companyNames.includes(c.name)).flatMap((c) => c.doc_titles || [])
  ));
  const isDelivered = ["delivered", "inv_generated", "inv_submitted", "paid"].includes(form.status);
  return (
    <div className="fixed inset-0 bg-black/50 z-40 flex items-start justify-center overflow-y-auto py-8" data-testid="lr-form-modal">
      <div className="bg-white w-full max-w-4xl mx-4">
        <div className="px-6 py-4 border-b border-[#E5E3DB] flex items-center justify-between">
          <h2 className="font-headings text-xl font-bold">{editingId ? "Edit LR" : "Create Lorry Receipt"}</h2>
          <div className="flex items-center gap-2">
            <button type="button" className="btn-secondary text-sm" onClick={() => setDirOpen(true)} data-testid="lr-add-directory-btn"><Plus className="w-4 h-4" /> Add to directory</button>
            <button className="btn-ghost" onClick={onClose} data-testid="lr-form-close"><X className="w-4 h-4" /></button>
          </div>
        </div>
        <form onSubmit={save} className="p-6 space-y-6">
          <BasicSection form={form} set={set} setForm={setForm} setH={setH} pickHirer={pickHirer} hirerContacts={hirerContacts} customers={customers} editingId={editingId} reloadCustomers={reloadCustomers} />
          <RouteSection form={form} set={set} setForm={setForm} setC={setC} customers={customers} subs={subs} editingId={editingId} reloadCustomers={reloadCustomers} />
          <CargoSection form={form} set={set} setForm={setForm} vehicles={vehicles} drivers={drivers} brokers={brokers} subs={subs} isDelivered={isDelivered} onPodFile={onPodFile} />
          <ExtrasSection form={form} set={set} customers={customers} companyDocTitles={companyDocTitles} editingId={editingId} lrDocTypes={lrDocTypes} />

          <div className="flex justify-end gap-3 pt-4 border-t border-[#E5E3DB]">
            <button type="button" className="btn-secondary" onClick={onClose}>Cancel</button>
            <button type="submit" disabled={saving} className="btn-primary" data-testid="lr-save-button">{saving ? "Saving..." : editingId ? "Update LR" : "Create LR"}</button>
          </div>
        </form>
      </div>
      <DirectoryWizardModal open={dirOpen} onClose={() => setDirOpen(false)} onChange={reloadCustomers} />
    </div>
  );
}
